import { AwsSecretSchema, type AwsSecret, type KvpsDealerId } from '@org-avp/models';
import { EXHIBITION_STAGE } from 'utils/ui/stage';
import { user } from './user';
import { getOAuthClient, isAuthenticated, refreshTokens } from '.';
import { IStage } from 'data/stage';

const avpDevicesTvmIdTokenEndpoint: Record<IStage, string> = {
  test: 'https://devices.develop.avp.tech/credentials/viaIdToken',
  dev: 'https://devices.develop.avp.tech/credentials/viaIdToken',
  prelive: 'https://devices.preprod.avp.tech/credentials/viaIdToken',
  prod: 'https://devices.avp.tech/credentials/viaIdToken',
};

export async function fetchCredentialsFromTvm(
  idToken: string,
  stage: IStage,
  dealerId: KvpsDealerId
): Promise<AwsSecret> {
  const tvmUrl = avpDevicesTvmIdTokenEndpoint[stage];
  const response = await fetch(`${tvmUrl}/${dealerId}`, { headers: { Authorization: `Bearer ${idToken}` } });
  if (!response.ok) {
    throw new Error(`Failed to fetch credentials: ${response.status}: ${response.statusText}`);
  }
  const json: unknown = await response.json();
  const credentials = AwsSecretSchema.safeParse(json);
  if (!credentials.success) {
    console.debug('Malformed credentials fetched from TVM', { error: credentials.error });
    throw new Error('Malformed backend data');
  }
  return credentials.data;
}

export async function tvmCredentialsProvider(): Promise<AwsSecret> {
  if (!EXHIBITION_STAGE) throw new Error('Stage not available');
  if (!user.dealerIdKvps) throw new Error('Dealer Id not available');

  if (!isAuthenticated()) {
    const userClient = getOAuthClient();
    const currentUser = await userClient.getUser();
    if (!currentUser) throw new Error('User not available');
    const refreshed = await refreshTokens(userClient, currentUser);
    if (!refreshed) throw new Error('Unable to refresh tokens');
  }

  const idToken = user?.getIdToken();
  if (!idToken) throw new Error('Id Token not available');
  return await fetchCredentialsFromTvm(idToken, EXHIBITION_STAGE, user.dealerId as KvpsDealerId);
}
